import omitBy from 'lodash/omitBy';

import { FilterSelect } from '@/modules/common/components';
import { OptionType } from '@/modules/common/types';

import { participantStatusOptions } from '../constants';
import { ParticipantsTableFiltersType } from '../types';

interface TableFiltersProps {
  types: OptionType[];
  filters: Partial<ParticipantsTableFiltersType>;
  setFilters: (filters: Partial<ParticipantsTableFiltersType>) => void;
}

export function ParticipantsTableFilters({
  types,
  filters,
  setFilters,
}: TableFiltersProps) {
  const handleFilterChange = (
    filter: keyof ParticipantsTableFiltersType,
    value: string
  ) => {
    setFilters(omitBy({ ...filters, [filter]: value }, (v) => v === ''));
  };

  return (
    <div className="flex gap-4 max-w-[1000px]">
      <div className="flex-1">
        <FilterSelect
          options={types}
          label="Type"
          value={filters.type}
          onChange={(value) => handleFilterChange('type', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={participantStatusOptions}
          label="Status"
          value={filters.status}
          onChange={(value) => handleFilterChange('status', value)}
        />
      </div>
    </div>
  );
}
